import { render, staticRenderFns } from "./MrfDeadlineList.vue?vue&type=template&id=6fa31856"
import script from "./MrfDeadlineList.vue?vue&type=script&lang=js"
export * from "./MrfDeadlineList.vue?vue&type=script&lang=js"
import style0 from "./MrfDeadlineList.vue?vue&type=style&index=0&id=6fa31856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports